/**
 * Remark plugin adapted from:
 * https://github.com/florianb/remark-description-list/blob/master/index.js
 */
const descriptionList = () => {
  function nodeMatches(node) {
    const pattern = new RegExp(/^(.+?[\r\n]+)+?:/gm);

    return (
      node.type === "paragraph" &&
      node.children.length === 1 &&
      node.children[0].type === "text" &&
      pattern.test(node.children[0].value)
    );
  }

  return (root) => ({
    ...root,
    children: root.children.map((c) => {
      if (!nodeMatches(c)) return c;

      const lines = c.children.shift().value.split(/\r?\n/);
      return {
        type: "descriptionList",
        children: lines.map((line) => {
          const isDetails = line[0] === ":";
          const type = isDetails ? "descriptionDetails" : "descriptionTerm";
          const value = isDetails ? line.slice(1) : line;
          return { type, children: [{ type: "text", value }] };
        }),
      };
    }),
  });
};

export { descriptionList };
